import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../i18n/messages';

import { TECHCHANGE_DEFAULT_IMAGE_404 } from '../../constants';

import './ErrorPage.scss';

const propTypes = {

	/**
	 * A custom react-intl message object to display as the error
	 * page header.
	 */
	header: PropTypes.shape({

		/**
		 * The ID of the message to be translated.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The description of the message to be translated.
		 */
		description: PropTypes.string,

		/**
		 * The message to be translated.
		 */
		defaultMessage: PropTypes.string.isRequired,

	}),

	/**
	 * A custom react-intl message object to display as the error
	 * page subheader which optionally contains a link to redirect the user.
	 */
	subheader: PropTypes.shape({

		/**
		 * The ID of the message to be translated.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The description of the message to be translated.
		 */
		description: PropTypes.string,

		/**
		 * The message to be translated.
		 */
		defaultMessage: PropTypes.string.isRequired,

	}),

	/**
	 * The link to generate for the user to be redirected to a valid location
	 * as part of the subheader.
	 */
	link: PropTypes.node,

};

const defaultProps = {
	header: messages.TC_COMPONENTS_ERROR_PAGE_HEADER,
	subheader: messages.TC_COMPONENTS_ERROR_PAGE_SUBHEADER,
};

/**
 * Shared component to render a TechChange 404 page.
 * Displays a header message and subheader message, which
 * should contain a link the user can click to be redirected.
 *
 * @param {Object} props The props.
 *
 * @returns {Object} The rendered component.
 */
const ErrorPage = (props) => {

	const {
		header,
		subheader,
		link,
		...restProps
	} = props;

	const className = 'bad-link-error-msg';

	if (restProps.className) {
		className.concat(' ', restProps.className);
	}

	return (
		<div className="bad-link-error-msg">
			<img
				alt=""
				src={TECHCHANGE_DEFAULT_IMAGE_404} />
			<div className="bad-link-header">
				<FormattedMessage {...header} />
			</div>
			<div className="bad-link-subheader">
				<FormattedMessage
					{...subheader}
					values={{ link }} />
			</div>
		</div>
	);

};

ErrorPage.propTypes = propTypes;
ErrorPage.defaultProps = defaultProps;

export default ErrorPage;
